import { InfoCircleOutlined } from '@ant-design/icons'
import React, { forwardRef } from 'react'
import { useTracking } from '../../hooks/useTracking'
import DetailCard from '../common/detail-card'
import styled from 'styled-components'
import theme from '../../theme'
import { getCurrency } from '../../utils/country'
type Props = {
  countryCode: string
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  font-weight: 100;
  font-size: 16px;
  line-height: 21px;
  color: ${theme.midnight800};
`
const Note = styled.div`
  color: ${theme.slate500};
  font-size: 10px;
  line-height: 21px;
`
const InfoCircleIcon = styled(InfoCircleOutlined)`
  margin-right: 4px;
`
function PaymentInfo(props: Props, ref: React.Ref<HTMLDivElement>) {
  const { countryCode } = props
  const { orderDetails } = useTracking()
  if (!orderDetails || orderDetails.serviceKind === 'partner_return' || !orderDetails?.paymentMode) {
    return null
  }

  const currency = getCurrency(countryCode)

  return (
    <DetailCard ref={ref} title={'💳 Pay on delivery'} data-testid="payment-info-card">
      <Content>
        {orderDetails?.paymentMode === 'pre_paid' ? (
          <div>This order is prepaid</div>
        ) : orderDetails?.paymentMode === 'paid_on_delivery' ? (
          <>
            <div>Have {orderDetails?.paymentAmount}{currency} ready</div>
            <Note>
              <InfoCircleIcon />
              Cash or card payment options available
            </Note>
          </>
        ) : null}
      </Content>
    </DetailCard>
  )
}
export default forwardRef(PaymentInfo)
